module.exports = __webpack_public_path__ + "img/LEAF-A.8d833a9e.svg";